import { render, staticRenderFns } from "./Contact.vue?vue&type=template&id=eb71e2f8&scoped=true&"
import script from "./Contact.vue?vue&type=script&lang=js&"
export * from "./Contact.vue?vue&type=script&lang=js&"
import style1 from "./Contact.vue?vue&type=style&index=1&id=eb71e2f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb71e2f8",
  null
  
)

export default component.exports